/* Giancarlo Paoli, hero video.

   Il video non ha src nel markup: qui si decide quale delle tre versioni
   scaricare, e solo dopo che il fermo immagine e' stato dipinto. Cosi' il primo
   schermo arriva quando arriva la fotografia, non quando arriva il video.

   Il video non ha traccia audio, quindi non serve nessun comando per il suono. */

(function () {
  'use strict';

  function avvia(sez) {
    var video = sez.querySelector('video');
    if (!video || video.dataset.gpAvviato) return;

    // Tre motivi per non far partire niente: l'autoplay e' spento nell'editor
    // tema, il sistema chiede meno movimento, oppure l'interruttore nel piede
    // del sito e' su off.
    if (!sez.hasAttribute('data-gp-hv-auto')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try {
      if (localStorage.getItem('gp-motion') === 'off') return;
    } catch (e) {}

    // La versione si sceglie dalla larghezza reale del riquadro moltiplicata per
    // la densita' dello schermo, non dalla larghezza della finestra: su telefono
    // il riquadro e' largo 390 punti e il 1080p sarebbe quattro megabyte buttati.
    var largo = sez.getBoundingClientRect().width * (window.devicePixelRatio || 1);
    var scelta = sez.getAttribute('data-gp-hv-sd');
    if (largo > 1500) scelta = sez.getAttribute('data-gp-hv-hd') || scelta;
    else if (largo > 900) scelta = sez.getAttribute('data-gp-hv-md') || scelta;
    if (!scelta) return;

    video.dataset.gpAvviato = '1';

    video.addEventListener('playing', function () {
      sez.setAttribute('data-gp-hv-attivo', '');
    }, { once: true });

    function parti() {
      video.src = scelta;
      video.load();
      var p = video.play();
      // Se il browser rifiuta l'autoplay non resta un buco: il fermo immagine
      // sta sotto e non lo copriamo mai.
      if (p && p.catch) p.catch(function () {});
    }

    var fermo = sez.querySelector('img');
    if (fermo && !fermo.complete) {
      fermo.addEventListener('load', parti, { once: true });
      fermo.addEventListener('error', parti, { once: true });
    } else if ('requestIdleCallback' in window) {
      requestIdleCallback(parti, { timeout: 1200 });
    } else {
      setTimeout(parti, 200);
    }

    // Fuori dallo schermo il video si mette in pausa: non serve decodificare
    // fotogrammi che nessuno sta guardando.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) {
        for (var i = 0; i < voci.length; i++) {
          if (!video.src) continue;
          if (voci[i].isIntersecting) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        }
      }, { threshold: 0 }).observe(sez);
    }
  }

  function scansiona(ambito) {
    var nodi = (ambito || document).querySelectorAll('[data-gp-hv]');
    for (var i = 0; i < nodi.length; i++) avvia(nodi[i]);
  }

  scansiona();

  // Nell'editor tema la sezione viene ricostruita a ogni modifica.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { scansiona(e.target); });
  }
})();
